<template>
  <div>
    <el-dialog
      :title="'添加场景'"
      :close-on-click-modal="false"
      top="5%"
      :visible.sync="showDialog"
      width="40%"
      label-width="80px"
    >
      <el-form
        :model="addform"
        ref="addform"
        :rules="myrules"
        label-width="100px"
      >
        <el-form-item label="品牌" prop="brandId">
          <el-select
            v-model="addform.brandId"
            clearable
            filterable
            @change="brandChange"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in brandSelectData"
              :key="index"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店" prop="hotelId">
          <el-select
            v-model="addform.hotelId"
            @change="hotelChange"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in hotelSelectData"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房型" prop="roomTypeId">
          <el-select
            v-model="addform.roomTypeId"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in roomTypeSelectData"
              :key="item.name"
              :label="item.typeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="语音类型" prop="applianceType">
          <el-select
            v-model="addform.applianceType"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option label="开关" value="SWITCH">开关</el-option>
            <el-option label="场景" value="SCENE_TRIGGER">场景</el-option>
            <el-option label="窗帘" value="CURTAIN">窗帘</el-option>
            <el-option label="纱帘" value="CURT_SIMP">纱帘</el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="场景名称" prop="sceneName">
          <el-input
            v-model.trim="addform.sceneName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item label="面板ID" prop="sceneId">
          <el-input
            v-model.trim="addform.sceneId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item label="按键位置" prop="loopNo">
          <el-input
            v-model.trim="addform.loopNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmAdd('addform')"
          :loading="loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  eidtKooFeeScene,
  getHotelSelect,
  getBrandSelect,
  getHotelRoomType,
} from "@/api";
export default {
  data() {
    return {
      loading: false,
      showDialog: false,
      hotelSelectData: null,
      addform: {
        id: null,
        brandId: null,
        hotelId: null,
        roomTypeId: null,
        applianceType: null,
        sceneId: null,
        sceneName: null,
        loopNo: null,
        val: null,
        extVal: null
      },
      seekData: {
        roomTypeId: null,
        brandId: null,
        hotelId: null,
        applianceType: null,
      },
      brandSelectData: null,
      roomTypeSelectData: null,
      type: 0,
      myrules: {
        brandId: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
        hotelId: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
        roomTypeId: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
        sceneName: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
        applianceType: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
        sceneId: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
        loopNo: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
        val: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
        extVal: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    initialize(obj) {
      getBrandSelect(obj).then((res) => {
        if (res.data.data) {
          this.brandSelectData = res.data.data;
        }
      });
    },
    brandChange(id) {
      this.addform.hotelId = null;
      this.addform.roomTypeId = null;
      getHotelSelect(id).then((res) => {
        if (res.data.data) {
          this.hotelSelectData = res.data.data;
        }
      });
    },
    hotelChange(id) {
      this.addform.roomTypeId = null;
      // 房间类型下拉框
      getHotelRoomType(id).then((res) => {
        if (res.data.data) {
          this.roomTypeSelectData = res.data.data;
        }
      });
    },
    confirmAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          eidtKooFeeScene(this.addform).then((_) => {
            this.showDialog = false;
            this.$emit("addViewClose");
          });
          return true;
        }
        return false;
      });
    },

    openSet(data) {
      this.showDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  width: 50px !important;
  height: 50px !important;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  height: 50px !important;
  line-height: 50px !important;
  text-align: center;
}
.avatar {
  height: 100px;
  padding: 5px;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  overflow: hidden;
  .avatarImg {
    height: 100px;
  }
  .del {
    right: -100%;
    transition: all 0.5s;
    overflow: hidden;
  }
  &:hover {
    .del {
      transition: all 0.5s;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      position: absolute;
      z-index: 5;
      right: 0;
      top: 0;
      text-align: center;
      line-height: 25px;
      background-color: rgba(0, 0, 0, 0.5);
      .delBtn {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>


